import { render, staticRenderFns } from "./Expansionboard.vue?vue&type=template&id=060e4a7e&scoped=true&"
import script from "./Expansionboard.vue?vue&type=script&lang=js&"
export * from "./Expansionboard.vue?vue&type=script&lang=js&"
import style0 from "./Expansionboard.vue?vue&type=style&index=0&id=060e4a7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060e4a7e",
  null
  
)

export default component.exports